import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./Report.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { format } from "date-fns";
import { ReportTappingMakananEntity } from "../../entities/ReportEnity";
import { ReportService } from "../../services/report";
import FilterUtils from "../../utils/filter-utils";

export default function ReportTappingMakanan() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const stateShowLoading = context.stateShowLoading
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //

  const [tableDataFilter, setTableDataFilter] = useState<{ [key: string]: string }>({});
  const [tableData, setTableData] = useState<ReportTappingMakananEntity[]>([]);
  const [filterDate, setFilterDate] = useState({
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd")
  });

  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handleGenerateExcel = async () => {
    if (tableData.length == 0) { return contextShowAlertFunc(new AlertEntity({ message: "NO DATA!", level: 3 })); }
    const column = ["id_card", "karyawan", "vendor", "lokasi", "shift", "tipe", "waktu_tapping", "porsi"];
    let values: { [key: string]: string }[] = [];
    let dataForExport = tableData.filter((row) => {
      return FilterUtils.FilterTable(row, tableDataFilter)
    })
    for (let i = 0; i < dataForExport.length; i++) {
      values.push({
        id_card: (dataForExport[i].id_card).toString(),
        karyawan: dataForExport[i].karyawan,
        vendor: dataForExport[i].vendor,
        lokasi: dataForExport[i].lokasi,
        shift: dataForExport[i].shift.toString(),
        tipe: dataForExport[i].tipe,
        waktu_tapping: dataForExport[i].datetime_in,
        porsi: dataForExport[i].porsi.toString(),
      })
    }
    ExcelUtils.export(`Tapping List on ${filterDate.start_date} until ${filterDate.end_date}`, column, values);
  }

  const generateData = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await ReportService.ReportTapping(filterDate.start_date, filterDate.end_date);
      setTableData(resp);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  };

  useEffect(() => {
    generateData();
  }, [contextAccessToken]);

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <Card
          detailTitle="Report Tapping Makanan"
          detailColor="var(--secondary-color)"
          backgroundImage={backgroundCard}
          stateShow={true}
          detailCard={
            <>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>Start Date :</label>
                  <input style={{ fontSize: "12px" }} type="date" value={filterDate.start_date}
                    onChange={(event) => setFilterDate(prevState => ({
                      ...prevState,
                      start_date: event.target.value
                    }))}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>End Date :</label>
                  <input style={{ fontSize: "12px" }} type="date" value={filterDate.end_date}
                    onChange={(event) => setFilterDate(prevState => ({
                      ...prevState,
                      end_date: event.target.value
                    }))}
                  />
                </div>
                <div>
                  <div style={{ color: "white", textAlign: "left" }}>&nbsp;</div>
                  <button className="cardButton" onClick={() => generateData()} >
                    Refresh
                  </button>
                </div>
                <div>
                  <button className="cardButton" onClick={() => handleGenerateExcel()} >
                    Generate Excel
                  </button>
                </div>
              </div>
              <div className={css.rowGrid} style={{ alignItems: 'end', marginTop: "1vh" }}>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>shift :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, shift: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>id card :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, id_card: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>karyawan :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, karyawan: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>vendor :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, vendor: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>lokasi :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, lokasi: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>tipe :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, tipe: event.target.value }));
                    }}
                  />
                </div>
              </div>
            </>
          }
        />
        <div
          style={{
            height: "65vh",
            overflow: "auto"
          }}>
          <table className="tableclickcell">
            {tableData.length > 0 ?
              <>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Waktu Tapping</th>
                    <th>Shift</th>
                    <th>ID Card</th>
                    <th>Karyawan</th>
                    <th>Vendor</th>
                    <th>Lokasi</th>
                    <th>Tipe</th>
                    <th>Porsi</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.filter((row) => {
                    return FilterUtils.FilterTable(row, tableDataFilter)
                  })
                    .map((row, idx) => {
                      return <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{row.datetime_in}</td>
                        <td>{row.shift}</td>
                        <td>{row.id_card}</td>
                        <td>{row.karyawan}</td>
                        <td>{row.vendor}</td>
                        <td>{row.lokasi}</td>
                        <td>{row.tipe}</td>
                        <td>{row.porsi}</td>
                      </tr>
                    })}
                </tbody>
              </>
              :
              <>
                <thead><tr><th>no data available yet!</th></tr></thead>
              </>
            }
          </table>
        </div>
      </div>
    </>
  );
}
